import ParamPairs, { ParamPair } from '../../lib/ParamPairs';

import * as $ from 'jquery';

import { Analytics } from '@plaudit/analytics';

export default class ProductSearchAbstract {
	protected params: ParamPairs;
	protected filterTrayEl: HTMLDivElement;
	protected excludedParams: string[] = ['page'];
	protected ga: Analytics = Analytics.getInstance();

	constructor() {
		this.params = new ParamPairs();
	}

	/**
	 * Returns a function with a specified scope, used as an event listener.
	 * Used for the mobile lightbox filter area. Should only clear selection and
	 * update the apply button, not immediately update results or submit form.
	 */
	protected clearFiltersInScope: Function = (scope: Element = document.body, callback?: Function): EventListener => {
		return (event: Event): void => {
			const filters: NodeListOf<HTMLInputElement> = scope.getElementsByTagName('input');
			for (let index: number = 0; index < filters.length; index++) {
				const element: HTMLInputElement = filters[index] as HTMLInputElement;

				if (element.checked) {
					element.checked = false;
				} else {
					element.value = '';
				}
			}

			this.params.destroy();

			if (callback) {
				callback();
			}
		};
	}

	protected addFilter(id: string, value: string): void {
		if (!value)
			return;

		const filterEl: HTMLInputElement = document.querySelector(`[id^="${id}"][value="${value}"]`) as HTMLInputElement;
		if (!filterEl)
			return;

		const filterTemplate: HTMLSpanElement = document.createElement('span');
		filterTemplate.classList.add('filterTray__filter');
		if (filterEl.type !== 'text') {
			filterTemplate.textContent = filterEl.getAttribute('data-label');
		} else {
			filterTemplate.textContent = filterEl.value;
		}
		filterTemplate.setAttribute('data-id', filterEl.id);

		const appendedNode: HTMLSpanElement = this.filterTrayEl.appendChild(filterTemplate);
		appendedNode.addEventListener('click', this.removeFilterCB);

		this.filterTrayEl.classList.remove('filterTray--empty');
	}
	protected removeFilter(id: string): void {
		const filterEl: Element = document.querySelector(`[data-id="${id}"]`);
		this.filterTrayEl.removeChild(filterEl);
	}

	protected removeFilterCB = (event: Event): void => {
		const filterTrayEl: Element = document.getElementsByClassName('filterTray')[0];
		const element: HTMLElement = event.currentTarget as HTMLElement;
		const id: string = element.getAttribute('data-id');
		const targetEl: HTMLInputElement = document.getElementById(id) as HTMLInputElement;

		if (targetEl.type !== 'text') {
			$(targetEl).click();
		} else {
			// Remove clicked
			filterTrayEl.removeChild(element);

			// Clear input and trigger Ajax
			targetEl.value = '';
			const event = document.createEvent('HTMLEvents');
			event.initEvent('change', true, false);
			targetEl.dispatchEvent(event);
		}
	}

	protected removeAllFilters(): void {
		const filterTrayEl: Element = document.getElementsByClassName('filterTray')[0];
		const filterTrayFilters = filterTrayEl.childNodes;
		for (let i = filterTrayFilters.length - 1; i >= 0; i--) {
			const element = filterTrayFilters[i] as HTMLElement;
			filterTrayEl.removeChild(element);
		}
	}

	/**
	 * Builds the filter tray from the currently active filters
	 * @param attachToElClass The class of the element to attach the filter tray to NOTE: Refactor to accept specific node? -SB 2017-11-15
	 * @param excludedQueries Query params to exclude from the filter tray, allowing different display on desktop or mobile.
	 */
	protected buildFilterTray(
		attachToElClass: string,
		options: {
			excludedQueries?: string[],
			clearFiltersEl?: Element,
			clearFiltersCB?: EventListener
		}): void {
		const attachToEl: Element = document.getElementsByClassName(attachToElClass)[0];
		if (!attachToEl)
			return;

		// Build and append filter tray
		const filterTrayElAbstr: HTMLDivElement = document.createElement('div');
		filterTrayElAbstr.classList.add('filterTray');
		this.filterTrayEl = attachToEl.insertBefore(filterTrayElAbstr, attachToEl.children[0]);

		// Initialize active filters
		for (let key in this.params.pairs) {
			if (this.params.pairs.hasOwnProperty(key)) {
				if (options.excludedQueries.indexOf(key) === -1) {
					const element: ParamPair = this.params.pairs[key];
					for (let index: number = 0; index < element.value.length; index++) {
						const value: string = element.value[index];

						// NOTE: This unfortunate hardcoded value would ideally be removed,
						// but would require refactoring of the Java code. -SB 2017-11-15
						if (value !== 'all') {
							this.addFilter(key, value);
						}
					}
				}
			}
		}

		if (!this.filterTrayEl.childElementCount) {
			this.filterTrayEl.classList.add('filterTray--empty');
		}

		if (!options.clearFiltersEl) {
			// Build 'Clear' button
			const clearFiltersElAbstr: HTMLSpanElement = document.createElement('span');
			clearFiltersElAbstr.classList.add('filterTray__clear');
			clearFiltersElAbstr.textContent = 'Clear All';
			options.clearFiltersEl = this.filterTrayEl.appendChild(clearFiltersElAbstr);
		}
		if (options.clearFiltersCB) {
			// Attach 'Clear' handler
			options.clearFiltersEl.addEventListener('click', options.clearFiltersCB);
		}
	}

	protected destroyFilterTrayWith = (callback: Function): EventListener => {
		return (event: Event) => {
			this.params.destroy();

			this.filterTrayEl.parentNode.removeChild(this.filterTrayEl);
			this.filterTrayEl = undefined;

			callback();
		};
	}
}